import styled from 'styled-components'
import { SupportedLanguage } from '@estercare/ester-shared'
import { theme } from '../../theme/theme'
import { BodyXlMedium, Title3 } from '../styles/Typography'
import { formatDayName, formatDayNumber } from '../../utils/dates'

interface DayHeaderProps {
  date: Date
  locale?: SupportedLanguage
}

export const DayHeader = ({ date, locale = SupportedLanguage.SWEDISH }: DayHeaderProps) => {
  const dayName = formatDayName(date, locale)
  const dayNumber = formatDayNumber(date)

  return (
    <HeaderContainer>
      <DayName>{dayName}</DayName>
      <DayNumber>{dayNumber}</DayNumber>
    </HeaderContainer>
  )
}

const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.spacing.xsmall}px;
  gap: 2px;
`

const DayName = styled(BodyXlMedium)`
  text-align: center;
  text-transform: capitalize;

  @media screen and (max-width: ${theme.breakpoint.large}px) {
    font-size: ${theme.fontSize.small}px;
    line-height: 16px;
    gap: 0px;
  }

  @media screen and (max-width: ${theme.breakpoint.small}px) {
    font-size: ${theme.fontSize.xxsmall}px;
  }
`

const DayNumber = styled(Title3)`
  text-align: center;
  @media screen and (max-width: ${theme.breakpoint.large}px) {
    font-size: ${theme.fontSize.medium}px;
    line-height: 20px;
  }
`
